<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div style="height: 500px; width: 100%">
        <h4>Tracking Kapal</h4>
        <div class="container-fluid my-5">
          <div class="row">
            <div class="col-4">
              <label class="d-block">Nama Kapal</label>
              <smart-search url="/api/inventaris/seeker/hardware-setup" :label-tag="['vessel','name']" key-tag="vessel_name" v-on:update="(data)=>smartSearchVessel(data)" :customvalue="selectedvessel"></smart-search>
            </div>
            <div class="col-4">
              <label class="d-block">ID Transmitter</label>
              <smart-search url="/api/inventaris/seeker/hardware-setup" :label-tag="['vessel','name']" key-tag="vessel_name" v-on:update="(data)=>smartSearchVessel(data)" :customvalue="selectedvessel"></smart-search>
            </div>
            <div class="col-4">
              <label class="d-block">Serial Number</label>
              <smart-search url="/api/inventaris/seeker/hardware-setup" :label-tag="['vessel','name']" key-tag="vessel_name" v-on:update="(data)=>smartSearchVessel(data)" :customvalue="selectedvessel"></smart-search>
            </div>
            <div class="col-4">
              <label class="d-block">Status Antena</label>
              <smart-select name="status" :options="statusTypeOptions" ></smart-select>
            </div>
            <div class="col-4">
              <label class="d-block">Status Kapal</label>
              <smart-select name="status" :options="statusTypeOptions" ></smart-select>
            </div>
            <div class="col-4">
              <b-button class="btn btn-success mt-4 py-2"><b>Cari</b></b-button>
            </div>
          </div>
        </div>
        <div style="height: 200px overflow: auto;">
          <button @click="showLongText">
            Toggle long popup
          </button>
          <button @click="showMap = !showMap">
            Toggle map
          </button>
        </div>
        <l-map
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 80%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        >
        <l-tile-layer
        :url="url"
        :attribution="attribution"
        />
        <l-marker :lat-lng="withPopup">
          <l-tooltip :options="{ permanent: true, interactive: true }">
            <div @click="innerClick">
              Vessel 1!
              <p v-show="showParagraph">
              </p>
            </div>
          </l-tooltip>
        </l-marker>
        <l-marker :lat-lng="withTooltip">
          <l-tooltip :options="{ permanent: true, interactive: true }">
            <div @click="innerClick">
              Vessel 2!
              <p v-show="showParagraph">
              </p>
            </div>
          </l-tooltip>
        </l-marker>
      </l-map>
    </div>
  </div>
</div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import { Icon } from 'leaflet';
import SmartSearch from '../../components/SmartSearch.vue';
import SmartSelect from '../../components/SmartSelect.vue';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    'smart-search':SmartSearch,
    'smart-select':SmartSelect
  },
  data() {
    return {
      selectedvessel:'',
      statusTypeOptions:[
      {label:'Update Posisi',value:'Update Posisi'},
      {label:'Update Battery',value:'Update Battery'},
      {label:'AC Mati, Battery On',value:'AC Mati, Battery On'},
      {label:'JB Dibuka',value:'JB Dibuka'},
      {label:'SOS Bahaya',value:'SOS Bahaya'}

      ],
      statusTypeOptions:[
      {label:'Kapal Aktif',value:'Kapal Aktif'},
      {label:'Kapal Tidak Aktif > 6jam',value:'Kapal Tidak Aktif > 6jam'},
      {label:'Kapal Tidak Aktif 1 Hari',value:'Kapal Tidak Aktif 1 Hari'},
      {label:'Kapal Dalam Bahaya',value:'Kapal Dalam Bahaya'}

      ],
      zoom: 6,
      center: latLng(-6.200000, 106.816666),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(-369954, 6410545),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
    };
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    smartSearchVessel(data){
      //console.log(data)
      // this.newSalesOrder.vesselId=data.vessel.id
      // this.selectedvessel=data.vessel.name
    },
    updateStatus(data){
      // this.newInvoiceItem.proforma=data
    },
  }
};
</script>
